import {ListItem} from "../../models/ListItem";
import {WISHLIST_BASE_URL_ABSOLUTE, WISHLIST_BASE_URL_RELATIVE} from "../../constants";

export const makeItemUrl = (item: ListItem, absolute = false) => {
  return `${absolute
    ? WISHLIST_BASE_URL_ABSOLUTE
    : WISHLIST_BASE_URL_RELATIVE}/i/${item.id}`;
};
